import React from "react";
import { red } from "@material-ui/core/colors";
import AutoRotatingCarousel from "./AutoRotatingCarousel";
import Slide from "./Slide";
import IconExcel from '../../assets/excelIconVerde.png'
import IconRar from '../../assets/rarIcon.png'
import { ViewPdf } from "./ViewPdf";

export const Carrousel = ({ mostrar, setMostrar, urls, titulo }) => {
  const esImagen = (url) => {
    let result = false;
    if (url.toLowerCase().search("pdf") === -1 && url.toLowerCase().search("xls") === -1 && url.toLowerCase().search("xlsx") === -1 && url.toLowerCase().search("rar") === -1 ) {
      result = true;
    }
    return result
  }

  const getOtherMedia = (url) => {
    if (url.toLowerCase().search(".xls") !== -1 || url.toLowerCase().search(".xlsx") !== -1) {
      return <img alt="Icon Excel" src={IconExcel} style={{ width: "100%" }} />
    } else if (url.search(".pdf") !== -1) {
      return <ViewPdf url={url} />
    } else if (url.includes(".rar")){
      return <img alt="Icon Rar" src={IconRar} style={{ width: "100%" }} />
    } else {
      return <p>Archivo con formato desconocido</p>
    }
  }

  return (
    <div>
      <AutoRotatingCarousel
        label="Get Info"
        open={mostrar}
        onClose={() => setMostrar(false)}
        onStart={() => setMostrar(false)}
        style={{ position: "absolute" }}
      >
        {
          urls.map((url, i) => (
            <Slide
              key={url.url}
              url={url.url}
              titulo={titulo}
              subtitle={`Documentación Número ${i + 1}`}
              media={esImagen(url.url) ? null : getOtherMedia(url.url)}
              mediaBackgroundStyle={{ backgroundColor: red[400] }}
              style={{ backgroundColor: 'white' }}
            />
          ))
        }
      </AutoRotatingCarousel>
    </div>
  );
};
